// GetBillsCategoriesList
import {
  GET_BILLS_CATEGORIES_START,
  GET_BILLS_CATEGORIES_SUCCESS,
  GET_BILLS_CATEGORIES_ERROR,
} from 'constants/action-types/payBills/getBillsCategories';
import apiAction from 'helpers/apiAction';

export default CountryCode => dispatch =>
  dispatch(
    apiAction({
      method: 'post',
      url: '/GetBillsCategoriesList',
      data: {
        CountryCode,
      },
      onStart: () => dispatch =>
        dispatch({
          type: GET_BILLS_CATEGORIES_START,
        }),
      onSuccess: data => dispatch => {
        return dispatch({
          type: GET_BILLS_CATEGORIES_SUCCESS,
          payload: {
            billsCategories: data,
          },
        });
      },
      onFailure: error => dispatch => {
        return dispatch({
          type: GET_BILLS_CATEGORIES_ERROR,
          payload: {
            error: error[0],
          },
        });
      },
    }),
  );
